.checklistDocumentsList {
    padding-left: 1rem;
}

.checklistDocumentsGroup {
    margin-bottom: 2rem;
}

.checklistDocumentsGroupHeading {
    font-size: 1rem;
    margin: 0 0 0.5rem 0;
}

.relatedList {
    list-style: none;
    padding: 0;
    margin: 0;
}

.relatedFile {
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;

    &:hover {
        background-color: rgb(243, 246, 247);
    }
}

.activeDocument {
    background-color: rgb(243, 246, 247);
    border-left: 2px solid rgb(1, 43, 60);
    padding-left: calc(0.5rem - 2px);
}

.noDocuments {
    display: flex;
    justify-content: center;
    padding: 2rem;
    color: var(--mantine-color-dimmed);
}

.documentRow {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.documentLink {
    color: var(--mantine-color-dark-4);
    text-decoration: none;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
        color: var(--mantine-color-gneis-5);
        text-decoration: underline;
    }
}

.fileRow {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    text-decoration: none;
    color: #012c3d;
}

.fileRow .fileRowLabel {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fileRow:hover .fileRowLabel {
    text-decoration: underline;
}

.fileRow .fileIcon {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
}

.fileRow .downloadIcon {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    color: #939aaf;
    display: none;
}

.fileRow:hover .fileIcon {
    display: none;
}

.fileRow:hover .downloadIcon {
    display: inline-block;
}
